import { useCallback } from 'react';

const getRandomNumber = (min: number, max: number): number => {
  const randomBuffer = new Uint32Array(1);
  window.crypto.getRandomValues(randomBuffer);
  const randomNumber = randomBuffer[0] / (0xffffffff + 1);
  return min + randomNumber * (max - min);
};

const useRandomNumber = () => {
  const generateRandomNumber = useCallback(
    (min: number, max: number): number => {
      return getRandomNumber(min, max);
    },
    []
  );

  return generateRandomNumber;
};

export default useRandomNumber;
